import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Header } from "./sections/Header";
import { Hero } from "./sections/Hero";
import { CaseStudies } from "./sections/CaseStudies";
import { Experience } from "./sections/Experience";
import { Contact } from "./sections/Contact";

gsap.registerPlugin(ScrollTrigger);

const App: React.FC = () => {
  useEffect(() => {
    // refresh ScrollTrigger after fonts load to ensure correct positions
    document.fonts.ready.then(() => {
      ScrollTrigger.refresh();
    });

    return () => {
      ScrollTrigger.getAll().forEach((t) => t.kill());
    };
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground antialiased">
      <Header />
      <main>
        <Hero />
        <CaseStudies />
        <Experience />
        <Contact />
      </main>
    </div>
  );
};

export default App;
